import { useState, useEffect } from 'react'
import { FaSatelliteDish, FaBars, FaXmark } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

const links = [
  { label: 'Home', href: '#hero' },
  { label: 'Tentang', href: '#tentang' },
  { label: 'Fitur', href: '#fitur' },
  { label: 'Cara Kerja', href: '#cara-kerja' },
  { label: 'Harga', href: '#harga' },
  { label: 'Testimoni', href: '#testimoni' },
  { label: 'Kontak', href: '#kontak' },
]

export default function Navbar({accessToken}) {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50)
    window.addEventListener('scroll', fn, { passive: true })
    return () => window.removeEventListener('scroll', fn)
  }, [])

  const [isScrolling, setIsScrolling] = useState(false)
const [active, setActive] = useState(null)
useEffect(() => {
  const sections = document.querySelectorAll('section[id]')

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActive(`#${entry.target.id}`)
        }
      })
    },
    {
      threshold: 0.6, // 60% terlihat baru dianggap aktif
    }
  )

  sections.forEach((section) => observer.observe(section))

  return () => observer.disconnect()
}, [])

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 w-full backdrop-blur-sm ${scrolled ? 'glass py-3' : 'py-5 bg-transparent'
        }`}
    >
      <nav
        className="w-full mx-auto px-6 flex items-center justify-between"
        aria-label="Navigasi utama"
      >
        {/* Logo */}
        <a
          href="#"
          className="flex items-center gap-3 group"
          aria-label="Radius Trend Beranda"
        >
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-ocean-800 to-ocean-600 flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-ocean-600/30">
            <FaSatelliteDish className="text-white text-lg" />
          </div>
          <span className="font-display font-bold text-xl text-white">
            Radius<span className="text-ocean-500">Trend</span>
          </span>
        </a>

        {/* Desktop Links */}
        <ul className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className={`block py-3 px-4 rounded-xl font-medium transition-all ${active === l.href
                    ? 'text-ocean-500 bg-navy-700/50'
                    : 'text-slate-custom hover:text-ocean-500 hover:bg-navy-700/50'
                  }`}
                  onClick={(e) => {
                    e.preventDefault()
                  
                    const el = document.querySelector(l.href)
                  
                    if (el) {
                      setIsScrolling(true)
                      setActive(l.href)
                  
                      const y =
                        el.getBoundingClientRect().top + window.pageYOffset - 90
                  
                      window.scrollTo({
                        top: y,
                        behavior: 'smooth',
                      })
                  
                      // kasih delay sesuai durasi scroll
                      setTimeout(() => {
                        setIsScrolling(false)
                      }, 500)
                    }
                  
                    setMobileOpen(false)
                  }}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Desktop CTA */}
        <div className="hidden lg:block">
          {accessToken ? (
            <Link to="/dashboard-menu" className="btn-primary text-sm">
              Masuk Sekarang
            </Link>
          ) : (
            <Link to="/login" className="btn-primary text-sm">
              Coba Gratis
            </Link>
          )}
        </div>

        {/* Hamburger */}
        <button
          className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
        >
          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-2' : ''
              }`}
          />
          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? 'opacity-0' : ''
              }`}
          />
          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-2' : ''
              }`}
          />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`mobile-menu fixed top-0 right-0 w-72 h-screen bg-navy-900/95 backdrop-blur-xl lg:hidden ${mobileOpen ? 'open' : ''
          }`}
        role="dialog"
        aria-label="Menu mobile"
      >
        <div className="p-6">
          <button
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-navy-700 transition mb-8"
            onClick={() => setMobileOpen(false)}
            aria-label="Tutup menu"
          >
            <FaXmark className="text-white text-xl" />
          </button>
          <ul className="flex flex-col gap-1">
            {links.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className={`block py-3 px-4 rounded-xl font-medium transition-all ${active === item.href
                    ? 'text-ocean-500 bg-navy-700/50'
                    : 'text-slate-custom hover:text-ocean-500 hover:bg-navy-700/50'
                  }`}
                  onClick={(e) => {
                    e.preventDefault()
                  
                    const el = document.querySelector(item.href)
                  
                    if (el) {
                      setIsScrolling(true)
                      setActive(item.href)
                  
                      const y =
                        el.getBoundingClientRect().top + window.pageYOffset - 90
                  
                      window.scrollTo({
                        top: y,
                        behavior: 'smooth',
                      })
                  
                      // kasih delay sesuai durasi scroll
                      setTimeout(() => {
                        setIsScrolling(false)
                      }, 500)
                    }
                  
                    setMobileOpen(false)
                  }}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          {accessToken ? (
            <Link to="/dashboard-menu" className="btn-primary text-sm">
              Masuk Sekarang
            </Link>
          ) : (
            <Link to="/login" className="btn-primary text-sm">
              Coba Gratis
            </Link>
          )}
        </div>
      </div>

      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/50 lg:hidden"
          style={{ zIndex: 40 }}
          onClick={() => setMobileOpen(false)}
        />
      )}
    </header>
  )
}